import React from "react";
import Button from "Components/button/Button";
import TranslatedString from "Components/TranslatedString";
import { t } from "i18next";
import cx from "classnames";
import Toggle from "Components/toggle/Toggle";
import _ from "lodash";
import { warningFill } from "Icons/index";

export default class Step1 extends React.Component {
  constructor(props) {
    super(props);
    this.goToNextStep = this.goToNextStep.bind(this);
    this.setValue = this.setValue.bind(this);
    this.state = {
      stepPermissions: [
        "see_domains",
        "create_domains",
        "disable_domains",
        "delete_domains",
        "manage_managers"
      ]
    };
  }

  setValue(data) {
    if (Object.keys(data)[0] === "see_domains" && data.see_domains === false) {
      this.props.domainRelatedPermissions.forEach(perm => {
        this.props.setFormFieldValue({ [perm]: false });
      });
    }

    this.props.setFormFieldValue(data);
  }

  goToNextStep(e) {
    const { setDataForm, goToStep } = this.props;

    e.preventDefault();
    setDataForm(this.state.formData);
    goToStep(3);
  }

  render() {
    const { formData, setFormFieldValue, formErrors, isFormLoading, permissions } = this.props;

    return (
      <div className="formsPage">
        {this.props.stepper}
        <div className={cx("sectionTitle", "titleFP")}>{t("teamMembers.add.title.step2")}</div>
        <div className="wrapScrollFP">
          <div className="infoFP">
            <div className="sectionDesc">{t("teamMembers.add.desc.step2")}</div>
            <Button className="btnDocsFP" docsKey="teamMembers_add" color="docs" sizeSmall>
              button.docs
            </Button>
          </div>

          <form className="wrapFormsFP" method="post" onSubmit={this.goToNextStep}>
            <div className="formsFP">
              {permissions.length > 0 &&
                _.compact(
                  permissions.map(per => {
                    if (!this.state.stepPermissions.includes(per.name)) return null;
                    return (
                      <Toggle
                        label={per.label}
                        name={per.name}
                        errors={formErrors[per.name]}
                        onChange={this.setValue}
                        className="inputFull2"
                        disabled={this.props.isDisabled(per.name)}
                        checked={
                          formData[per.name] && !formData.see_domains
                            ? !this.props.isDisabled(per.name)
                            : formData[per.name]
                        }
                      />
                    );
                  })
                )}
            </div>

            {formErrors.onForm && (
              <div className="warningMsgFP">
                <Icon className="iconWarningMsgFP" svg={warningFill} width="1rem" height="1rem" />
                <div className="textWarningMsgFP">{formErrors.onForm}</div>
              </div>
            )}

            <div className="footerFP">
              <Button color="text" type="button" onClick={this.props.backToList}>
                button.cancel
              </Button>
              <Button color="accent" type="submit" loading={isFormLoading}>
                button.continue
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
